import React, { useState } from 'react';

const Investimento: React.FC = () => {
    const [valor, setValor] = useState('');
    const [taxa, setTaxa] = useState('');
    const [tempo, setTempo] = useState('');

    const calcularInvestimento = () => {
        if (!valor || !taxa || !tempo) return null;

        const V = parseFloat(valor);
        const i = parseFloat(taxa) / 100;
        const t = parseInt(tempo);

        const montante = V * Math.pow(1 + i, t);
        const rendimento = montante - V;

        return {
            montante: montante.toFixed(2),
            rendimento: rendimento.toFixed(2),
            capital: V.toFixed(2)
        };
    };

    const resultado = calcularInvestimento();

    return (
        <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculadora de Investimento</h3>

            <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Valor investido (R$)
                                <input
                                    type="number"
                                    value={valor}
                                    onChange={(e) => setValor(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="1000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Taxa de retorno anual (%)
                                <input
                                    type="number"
                                    value={taxa}
                                    onChange={(e) => setTaxa(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="8"
                                    step="0.1"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Tempo (anos)
                                <input
                                    type="number"
                                    value={tempo}
                                    onChange={(e) => setTempo(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="5"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    {resultado && (
                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-indigo-900 mb-4">Resultado:</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Capital inicial:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.capital}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Rendimento:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.rendimento}</span>
                                </div>
                                <div className="flex justify-between text-lg">
                                    <span className="text-indigo-700">Montante final:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.montante}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Investimento;
